import merchantGatewayApi from '../merchant-gateway/api';
import { SigneeInformation, User } from '../merchant-onboarding-service/types';

const MERCHANT_ACCESS_CONTROL_PATH_PREFIX = '/merchant-access-control/v1';

export const createUser = (user: User, emailToken: String, onboardingToken: String): Promise<{ id: string }> =>
  merchantGatewayApi.post(
    `${MERCHANT_ACCESS_CONTROL_PATH_PREFIX}/user-sign-up`,
    {
      country: user.country,
      email: user.email,
      first_name: user.firstName,
      last_name: user.lastName,
      phone_number: user.phoneNumber,
      email_token: emailToken,
    },
    {
      headers: {
        Authorization: `Bearer ${onboardingToken}`,
      },
    },
  );

export const getMacSigneeInformation = (token: String) =>
  merchantGatewayApi
    .get(`${MERCHANT_ACCESS_CONTROL_PATH_PREFIX}/user-sign-up?token=${token}`)
    .then(response => response.data as SigneeInformation);
